// extracted by mini-css-extract-plugin
export var content = "styles-module--content--eae21";